import { mannaColors } from './index';

const { red, purple } = mannaColors;

/**
 * The order states that an order can be in prior to being in prepared (We only want to include states where the order is visable to the merchant)
 */
export const ACTIVE_ORDER_STATUSES_BEFORE_PREPARED = [
  'STORE_ACCEPTED',
  'STORE_PREPARING',
];

export const orderStatuses = {
  CREATED: {
    name: 'New Order',
    value: 0,
    color: '#ffe01a'
  },
  ACCEPTED: {
    name: 'Accepted',
    value: 10,
    color: '#d2232a'
  },
  STORE_ACCEPTED: {
    name: 'Store Accepted',
    value: 10,
    color: '#d2232a'
  },
  STORE_REJECTED: {
    name: 'Store Rejected',
    value: 0,
    color: red
  },
  PREPARING: {
    name: 'Preparing',
    value: 20,
    color: '#fc5000'
  },
  STORE_PREPARING: {
    name: 'Store Preparing',
    value: 20,
    color: '#fc5000'
  },
  STORE_PREPARED: {
    name: 'Store Prepared',
    value: 20,
    color: '#fc5000'
  },
  RECEIVED_FROM_STORE: {
    name: 'Received',
    value: 20,
    color: '#fc5000'
  },
  PREPARED: {
    name: 'Prepared',
    value: 30,
    color: '#fc5000'
  },
  UNAVAILABLE: {
    name: 'Unavailable',
    value: 0,
    color: red
  },
  READY: {
    name: 'Ready',
    value: 60,
    color: '#4BE72F'
  },
  READY_V2: {
    name: 'Ready V2',
    value: 60,
    color: '#4BE72F'
  },
  DISPATCHED: {
    name: 'Dispatched',
    value: 80,
    color: '#009fe3'
  },
  DELIVERED: {
    name: 'Delivered',
    value: 100,
    color: '#005aaa'
  },
  COMPLETE: {
    name: 'Complete',
    value: 100,
    color: '#d3d3d3'
  },
  COMPLETE_BYCAR: {
    name: 'Complete[By Car]',
    value: 0,
    color: '#d3d3d3'
  },
  REJECTED: {
    name: 'Rejected',
    value: 0,
    color: red
  },
  CANCELLED: {
    name: 'Cancelled',
    value: 0,
    color: '#d3d3d3'
  },
  RESET: {
    name: 'Reset',
    value: 0,
    color: 'gray'
  },
  ABORTED: {
    name: 'Aborted',
    value: 0,
    color: red
  },
  DEV: {
    name: 'DEV',
    value: 0,
    color: purple
  },
  STORE_UNAVAILABLE: {
    name: 'Store unavailable',
    value: 0,
    color: red
  }
};

export const orderStatusSequence = [
  'CREATED',
  'ACCEPTED',
  'STORE_ACCEPTED',
  'STORE_PREPARING',
  'STORE_PREPARED',
  'RECEIVED_FROM_STORE',
  'READY',
  'DISPATCHED',
  'DELIVERED',
  'COMPLETE'
];

export const STATUS_ARRAY = [
  'ACCEPTED',
  'STORE_ACCEPTED',
  'STORE_UNAVAILABLE',
  'STORE_REJECTED',
  'STORE_PREPARED',
  'STORE_PREPARING',
  'RECEIVED_FROM_STORE',
  'PREPARING',
  'PREPARED',
  'READY',
  'DISPATCHED',
  'DELIVERED',
  'COMPLETE',
  'COMPLETE_BYCAR',
  'REJECTED',
  'UNAVAILABLE',
  'CANCELLED',
  'RESET',
  'DEV'
];

export const PAST_READY_STATUS_ARRAY = [
  'RECEIVED_FROM_STORE',
  'READY',
  'DISPATCHED',
  'DELIVERED',
  'COMPLETE',
  'COMPLETE_BYCAR',
  'REJECTED'
];
export const BLOCKED_REASONS = {
  CLOSED_WIND: {
    text: 'Wind'
  },
  CLOSED_RAIN: {
    text: 'Rain'
  },
  BLOCKED_TECH_DRONE: {
    text: 'Tech Drone'
  },
  BLOCKED_TECH_ORDER: {
    text: 'Tech Order'
  },
  BLOCKED_TECH_BASE: {
    text: 'Tech Base'
  },
  BLOCKED_OP_BUFFER: {
    text: 'Op Buffer'
  },
  BLOCKED_OP_BIG_ORDER: {
    text: 'Op Big Order'
  },
  BLOCKED_OP_RESEND_ORDER: {
    text: 'Op Resend Order'
  },
  BLOCKED_OP_STAFF_BREAK: {
    text: 'Op Staff Break'
  },
  DISABLED_CLOSED: {
    text: 'Disabled Closed'
  },
  CLOSED_OTHER: {
    text: 'Closed Other'
  },
  BLOCKED_OTHER: {
    text: 'Blocked Other'
  }
};

export const TESCO_FD_ACCESS_TOKEN = 'e2d6bd2c866a89c5ac4c1fafd2be727f';
export const THOMAS_AND_CO_ACCESS_TOKEN = '56a71b96adf0e746ba783b934718b5a7';

export const STORE_TOKENS = {
  '15148': TESCO_FD_ACCESS_TOKEN,
  '15456': THOMAS_AND_CO_ACCESS_TOKEN
};

export const sendMessageToCustomer = {
  0: store =>
    `Due to the current rainy conditions, your order from ${store} will be cancelled. You will be refunded the delivery charge for this inconvenience. We hope that you will order again soon.`,

  1: store =>
    `Due to the current windy conditions, your order from ${store} will be cancelled. You will be refunded the the delivery charge for this inconvenience. We hope that you will order again soon.`,

  2: store =>
    `Due to the current poor weather conditions, your order from ${store} will be cancelled. You will be refunded the the delivery charge for this inconvenience. We hope that you will order again soon.`,

  3: store =>
    `Due to unscheduled maintenance, your order from ${store} will be cancelled. You will be refunded the the delivery charge for this inconvenience. We hope that you will order again soon.`,

  4: store =>
    `Due to technical issues, your order from ${store} will be cancelled. You will be refunded the the delivery charge for this inconvenience. We hope that you will order again soon.`,

  5: store =>
    `There is a delay with your order from ${store}. We apologies for this delay and will have your order to you as soon as possible. We will let you know as soon as your order is ready and when it has taken off.`,

  6: store =>
    `Due to the volume of your order from ${store}, it will be delivered over two trips. Enjoy!`,

  7: () =>
    `Quick action needed for your order: Please open the Manna app, tap “Choose Delivery Spot,” and select your preferred delivery spot. Ensure it's clear of obstructions for a smooth delivery. Thank you!`,

  8: () => `Drone delivery arriving soon
🏡 Stay inside. Wait until the drone flies away before collecting your package.
❌ Do not cut or pull on the string when it's being delivered: Interfering with the package or the string could be hazardous.

Thank you for ensuring a safe delivery!`

};

export enum Swimlanes {
  NEW_ORDER = 0,
  WITH_OUTLET = 1,
  READY_TO_GO = 2
}

export enum OrdersForOpsStatuses {
  DELIVERED = 'DELIVERED',
  CHANGE_CASSETTE = 'CHANGE_CASSETTE',
  DISPATCHED = 'DISPATCHED',
  READY = 'READY',
  RECEIVED_FROM_STORE = 'RECEIVED_FROM_STORE'
}

export enum LoadingOrderOpsStatus {
  LOAD_NOW = 'LOAD_NOW', 
  CHANGE_CASSETTE = 'CHANGE_CASSETTE',
  DISPATCHED = 'DISPATCHED', 
  COMPLETE = 'COMPLETE', 
  DELIVERED = 'DELIVERED', 
  WAIT = 'WAIT',
}

export enum OrderMissionStatus {
  PROPOSED = 'PROPOSED',
  CREATED = 'CREATED',
  HOLD = 'HOLD',
  IN_PROGRESS = 'IN_PROGRESS',
  MANUAL = 'MANUAL',
  ABORTED = 'ABORTED',
  COMPLETED = 'COMPLETED',
};

export enum DroneStatus {
  STANDBY = 'STANDBY',
  MISSION = 'MISSION',
  ABORT = 'ABORT',
  MAINTENANCE = 'MAINTENANCE',
  MOTORSTEST = 'MOTORSTEST',
};
